import React from 'react';
import { MonetizationOn } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const FRListingPret: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Module Prêts · Listing"
      icon={<MonetizationOn />}
      endpoint="module-pret"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection caisse',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
        { key: 'Min', label: 'Montant min', type: 'number', defaultValue: 0 },
        { key: 'Max', label: 'Montant max', type: 'number', defaultValue: 0 },
      ]}
      fileNamePrefix="rapport_listing_pret"
    />
  );
};

export default FRListingPret;
